import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const enableIms = {
  name: "enableIms" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ success: z.boolean(), workflowId: z.string() }),
};
